$(function() {
    /*$('li.submenu-hide').click(function() {
        $(this).addClass('submenu-show');
        $(this).removeClass('submenu-hide');
        //$(this).children('.drawer-menu__list--sub').removeClass('visible');
    });*/

    $('li.submenu').on('click', function() {
    	if (!$(this).hasClass('submenu-show') && $(this).hasClass('submenu-hide')) {
    		$(this).addClass('submenu-show');
        	$(this).removeClass('submenu-hide');
    	} else { 
    		//(!$(this).hasClass('submenu-hide') && $(this).hasClass('submenu-show') ) {
	    	$(this).addClass('submenu-hide');
	        $(this).removeClass('submenu-show');
	        $(this).children('.drawer-menu__list--sub').removeClass('visible');
    	}
    });

});
